/* eslint-disable */
import React, { useEffect, useContext, useRef, useState } from "react";
import styled from "styled-components";
import AppContext from "../../../../context/store";

import { Grid, Column } from "../../../../theme/Grid";
import AutocompleteInput from "../../../../theme/CustomMUI/AutoComplete";
import Button from "../../../../theme/Button";
import Select from "../../../../theme/CustomMUI/Select";
import AlertDialog from "../../../../theme/CustomMUI/AlertDialog";
import DatePickerInput from "../../../../theme/CustomMUI/DatePickerInput";
import MaskedInput from "../../../../theme/CustomMUI/MaskedInput";
import Axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import {
  AddBox,
  AddOutlined,
  InfoOutlined,
  Layers,
  Menu,
  Search,
  Warning,
  Edit
} from "@material-ui/icons";
import { Tooltip, TextField, InputAdornment, IconButton } from "@material-ui/core";
import { flushSync } from "react-dom";
import RemainingDebtRed from "../../../../assets/images/svg/remaining_debt_red.svg";
import StaffSelect from "../../../../theme/CustomMUI/StaffSelect";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import Cash from "../../../../assets/images/svg/cash.svg";
import Credit from "../../../../assets/images/svg/credit.svg";
import Transfer from "../../../../assets/images/svg/transfer.svg";
import CustomerPoint from "../../../../assets/images/svg/customer_point.svg";
import CashWhite from "../../../../assets/images/svg/cash_white.svg";
import CreditWhite from "../../../../assets/images/svg/credit_white.svg";
import CustomerPointWhite from "../../../../assets/images/svg/customer_point_white.svg";
import TransferWhite from "../../../../assets/images/svg/transfer_white.svg";
import RemainingDebt from "../../../../assets/images/svg/remaining_debt.svg";
import AppointmentCardDetail from "../../../../components/Dialogs/AppointmentCardDetail";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const themeForDatePicker = createTheme({
  typography: {
    fontSize: 11,
  },
});

/**
 * Hizmet satışının yapıldığı, verilerin düzenlendiği alan.
 */
export const _ServiceSalesBuilder = ({
  checkout_data,
  lateCheckout,
  setLateCheckout,
  setCheckoutData,
  getTotalAmounts,
  setServicesDetailDialogModal,
  _service_transaction,
  setServiceTransaction,
  setSelectedStaffServices,
  staffs,
  rooms,
  setServiceTransactionModal,
  services,
  customer_s,
  setDiscountTarget,
  setDiscountModal,
  setDiscountValue,
  setDiscountType,
  print_dialog,
  stock_items,
  customer,
  singlePaymentAndInstallmentPayment,
  advanced_date,
  advanced_type,
  setAdvancedDate,
  setAdvancedType,
  setAdvancedStaff,
  setPaymentSelectStaff,
  payment_select_staff,
  advanced_amount,
  setAdvancedAmount,
  hasUnsavedChanges,
  setHasUnsavedChanges,
  is_change,
  saveSingleReceipt,
  lastSaveTimestamp,
  setLastSaveTimestamp,
  // Appointment-related props
  setCheckoutDataDialog,
  setSelectedReceiptId,
  setSelectedTime,
  setSelectedDate,
  setSelectedService,
  setSelectedStaff: setSelectedStaffParent,
  packageChanges,
  getSingleReceipt,
}) => {
  const context = useContext(AppContext);
  let total_mount = 0;
  const rounded_amount = Math.round(getTotalAmounts().services);
  const [installment_dialog, setInstallmentDialog] = useState(false);
  const [installment_date, setInstallmentDate] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selected_installment, setSelectedInstallment] = useState(null);
  const [selected, setSelected] = useState(null);
  const [addPayment_dialog, setAddPaymentDialog] = useState(false);
  const [saveCashDialogOpen, setSaveCashDialogOpen] = useState(false);
  const [saveCreditDialogOpen, setSaveCreditDialogOpen] = useState(false);

  // Appointment-related states
  const [appointmentDetailModal, setAppointmentDetailModal] = useState(false);
  const [_appointment, set_Appointment] = useState(null);
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [shortCode, setShortCode] = useState(null);
  const [smsTemplates, setSmsTemplates] = useState([]);
  const [weeklyAppointments, setWeeklyAppointments] = useState([]);
  const [hourDetail, setHourDetail] = useState({
    start_hour: context.state.company_shift.start_hour,
    end_hour: context.state.company_shift.end_hour,
  });
  const [selectedStaffs, setSelectedStaffs] = useState(null);
  const [timeUpgrade, setTimeUpgrade] = useState(null);
  const [skipRefresh, setSkipRefresh] = useState(false);
  const [createAppointmentModal, setCreateAppointmentModal] = useState(false);
  const [personnelRoomEditKey, setPersonnelRoomEditKey] = useState(null);

  // Component unmount olurken dialog'ları kapat
  useEffect(() => {
    return () => {
      setSaveCashDialogOpen(false);
      setSaveCreditDialogOpen(false);
    };
  }, []);

  const getInstallmentDiffTotal = (count) => {
    const total = selected?.amount;
    return count > 0
      ? total / count
      : 0
    console.log(count);
  };

  const getAppointment = async (appointment_id) => {
    try {
      const { data } = await Axios.get(`${context.api_endpoint}/company/appointments/${appointment_id}`);

      if (data) {
        setHourDetail({
          start_hour: moment(
            data.appointment_start_date
          ).format("HH:mm"),
          end_hour: moment(
            data.appointment_end_date
          ).format("HH:mm"),
        });
        set_Appointment(data);

        setAppointmentDate(
          data.appointment_start_date
        );
        setSelectedStaffs(data.staff);
        setCreateAppointmentModal(true);
        try {
          const response = await Axios.get(
            `${context.api_endpoint}/company/shortcode/list/keyword`
          );
          if (response.status === 200) {
            setShortCode(response.data.data.keyword);
          }
        } catch (error) {
          console.error("Error fetching shortcode:", error);
        }

        try {
          const { data } = await Axios.get(
            `${context.api_endpoint}/company/sms/template/all`
          );
          setSmsTemplates([...data.data]);
        } catch (error) {
          console.error("Error fetching SMS templates:", error);
        }
      }
    } catch (error) {
      console.error("Randevu detayları alınamadı:", error);
      toast.error(context.t("appointments.getAppointmentError"));
    }
  };

  const getAppointmentsForSelectBox = async () => {
  };

  const updateAppointmentState = async (appointmentId, customerState) => {
    await Axios.put(
      `${context.api_endpoint}/company/appointment/customer/state`,
      {
        appointment_id: appointmentId,
        customer_state: customerState,
      }
    )
      .then((response) => {
        if (response.status === 200) {
          getAppointmentsForSelectBox();
          toast.success(
            context.t(
              `appointments.detail.appointmentStatus.changeStatusSuccessToast`
            )
          );
        }
      })
      .catch((e) => {
        if (e.response.status === 401) {
          toast.error(e.response.data.message);
        } else {
          toast.warning(e.response.data.message);
        }
      });
  };

  useEffect(() => {
    console.log(checkout_data.services)
  }, [checkout_data.services])
  const inputRef = useRef();


  useEffect(() => {
    if (is_change === true) {
      saveSingleReceipt();
      // Adisyon kaydedildiğinde, kaydedilmemiş değişiklikler işaretini temizle
      setHasUnsavedChanges(false);
      setSaveCashDialogOpen(false);
      setSaveCreditDialogOpen(false);
      setInstallmentDialog(true);
      setAddPaymentDialog(true);
    }
  }, [is_change, saveSingleReceipt, setHasUnsavedChanges]);

  // Ödeme işlemlerini yapmadan önce değişiklikleri kontrol eden fonksiyon
  const checkUnsavedChangesBeforePayment = (callback) => {
    // Son kaydetme işleminden sonra 10 saniye geçmiş mi kontrol et
    const isRecentlySaved = lastSaveTimestamp && (Date.now() - lastSaveTimestamp) < 10000;

    if (hasUnsavedChanges && !isRecentlySaved) {
      setSaveCashDialogOpen(true);
    } else {
      callback();
    }
  };
  const checkUnsavedChangesBeforePaymentCredit = (callback) => {
    // Son kaydetme işleminden sonra 10 saniye geçmiş mi kontrol et
    const isRecentlySaved = lastSaveTimestamp && (Date.now() - lastSaveTimestamp) < 10000;

    if (hasUnsavedChanges && !isRecentlySaved) {
      setSaveCreditDialogOpen(true);
    } else {
      callback();
    }
  };

  // Adisyonu kaydet ve sonra callback'i çalıştır
  const saveReceiptAndContinue = (callback) => {
    saveSingleReceipt();
    setSaveCashDialogOpen(false);
    setSaveCreditDialogOpen(false);
    setLastSaveTimestamp(Date.now());
    setAddPaymentDialog(true)
    setHasUnsavedChanges(false);
    if (callback) {
      callback();
    }
  };

  const saveReceiptAndContinueCredit = (callback) => {
    saveSingleReceipt();
    setSaveCashDialogOpen(false);
    setSaveCreditDialogOpen(false);
    setLastSaveTimestamp(Date.now());
    setInstallmentDialog(true)
    setHasUnsavedChanges(false);
    if (callback) {
      callback();
    }
  };


  return (
    <SectionBox style={{ overflowX: "hidden" }}>
      <AppointmentCardDetail
        _appointment={_appointment}
        set_Appointment={set_Appointment}
        updateAppointmentState={updateAppointmentState}
        setAppointmentDetailModal={setAppointmentDetailModal}
        setCreateAppointmentModal={setCreateAppointmentModal}
        appointmentDetailModal={appointmentDetailModal}
        hourDetail={hourDetail}
        setHourDetail={setHourDetail}
        weeklyAppointments={weeklyAppointments}
        timeUpgrade={timeUpgrade}
        setTimeUpgrade={setTimeUpgrade}
        selectedStaff={selectedStaffs}
        getAppointmentsForSelectBox={getAppointmentsForSelectBox}
        setAppointmentDate={setAppointmentDate}
        appointmentDate={appointmentDate}
        shortCode={shortCode}
        smsTemplates={smsTemplates}
        setSkipRefresh={setSkipRefresh}
        isReceiptPackage={true}
        getSingleReceipt={getSingleReceipt}
      />
      <SectionHeading
        style={{
          backgroundColor: "rgba(13, 78, 108, 0.04)",
          color: "#3189ec",
          border: "1px solid #3189ec",
          padding: "10px",
          borderRadius: "5px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div
          className="detail-search"
          style={{
            backgroundColor: "#3189ec",
          }}
          onClick={() => {
            setServicesDetailDialogModal(true);
            console.log(123);
          }}
        >
          <Search style={{ color: "white", fontSize: "20px" }} />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Layers />
          <h3 style={{ marginLeft: "15px" }}>
            {context.t(
              `['receipt/detail/id'].serviceTransactions.title`
            )}
          </h3>
        </div>
        <div>
          <AddBox
            style={{ cursor: "pointer", fontSize: "36px" }}
            onClick={() => {
              setServiceTransaction({
                ..._service_transaction,
                process_date: moment().format("YYYY-MM-DD"),
              });
              setSelectedStaffServices(null);
              setServiceTransactionModal(true);
            }}
          />
        </div>
      </SectionHeading>
      <ListSection className="no-scroll-bar">
        {
          //Hizmet Listesi
          Object.keys(checkout_data.services).filter(
            (key) => checkout_data.services[key] !== undefined
          ).length > 0 ? (
            Object.keys(checkout_data.services).map(
              (key, index) => {
                if (checkout_data.services[key] === undefined ||
                  checkout_data.services[key].process_type === 1) return null;
                const isEditingRow = personnelRoomEditKey === key;
                return (
                  <Grid className="no-gutters-row" key={index}>
                    <Column className="xs-12 sm-12 md-12 mt-1 lg-2">
                      <MuiThemeProvider theme={themeForDatePicker}>
                        <DatePickerInput
                          className="mb-1"
                          label={context.t(
                            `['receipt/detail/id'].serviceTransactions.dateInputLabel`
                          )}
                          error={false}
                          value={
                            moment(
                              checkout_data.services[key].process_date
                            ).format("YYYY-MM-DD") === "0001-01-01"
                              ? null
                              : moment(
                                checkout_data.services[key].process_date
                              )
                          }
                          onChange={(process_date) => {
                            setCheckoutData({
                              ...checkout_data,
                              services: {
                                ...checkout_data.services,
                                [key]: {
                                  ...checkout_data.services[key],
                                  process_date:
                                    moment(process_date).format(
                                      "YYYY-MM-DD"
                                    ),
                                },
                              }
                            });
                          }}
                        />
                      </MuiThemeProvider>
                    </Column>
                    <Column className="xs-12 sm-12 md-12 lg-2">
                      <Select
                        className="mb-1"
                        label={context.t(
                          `['receipt/detail/id'].serviceTransactions.nameInputLabel`
                        )}
                        items={
                          checkout_data.services[key].staff_id
                            ? staffs
                              ?.filter(
                                (staff) =>
                                  staff.id ===
                                  checkout_data.services[key].staff_id
                              )[0]
                              ?.services?.map((service) => service.service)
                            : services
                        }
                        deletedService={staffs
                          ?.filter(
                            (staff) =>
                              staff.id ===
                              lateCheckout?.services[key]?.staff_id
                          )[0]
                          ?.services?.map((service) => service.service)?.includes(services.filter((el) => el.id === lateCheckout?.services[key]?.service_id)?.map((data) => {
                            return ({
                              ...data,
                              is_passive: true
                            })
                          })) ? [] : services?.filter((el) => el.id === lateCheckout?.services[key]?.service_id)?.map((data) => {
                            return ({
                              ...data,
                              is_passive: true
                            })
                          })}
                        serviceDisabled={true}
                        selected={
                          checkout_data?.services[key]?.service_id
                            ? services?.filter(
                              (item) =>
                                item.id ===
                                checkout_data.services[key].service_id
                            )?.length
                              ? checkout_data.services[key].service_id
                              : context.t(`["receipt/detail/id"].deletedService`)
                            : context.t(`["receipt/detail/id"].deletedService`)
                        }
                        labelKey="name"
                        valueKey="id"
                        title={
                          services.filter(
                            (item) =>
                              item.id ===
                              checkout_data.services[key].service_id
                          ).length > 0
                            ? services.filter(
                              (item) =>
                                item.id ===
                                checkout_data.services[key].service_id
                            )[0].name
                            : context.t(`["receipt/detail/id"].deletedService`)
                        }
                        handler={(service_id) => {
                          setCheckoutData({
                            ...checkout_data,
                            services: {
                              ...checkout_data.services,
                              [key]: {
                                ...checkout_data.services[key],
                                service_id: parseInt(service_id),
                                process_type: 2,
                              },
                            }
                          });
                        }}
                      />
                    </Column>
                    {/* Personel + Oda - Edit modunda iki ayrı kolon, değilse tek kolonda readonly/selectörler */}
                    {(() => {
                      const svc = checkout_data.services[key];
                      const staffId = svc?.staff_id;
                      const roomId = svc?.room_id;
                      const bothSet = !!(staffId && roomId);
                      const anySet = !!(staffId || roomId);

                      const staffObj = staffId ? staffs?.find(s => s.id === staffId) : null;
                      const roomObj = roomId ? (rooms || []).find(r => (r.ID || r.id) === roomId) : null;
                      const roomName = roomObj ? (roomObj.Name || roomObj.name) : "";
                      const staffName = staffObj?.full_name || "";

                      const applyStaff = (staff_id) => {
                        const next = {
                          ...checkout_data,
                          services: {
                            ...checkout_data.services,
                            [key]: {
                              ...checkout_data.services[key],
                              staff_id: parseInt(staff_id),
                              process_type: 2,
                            },
                          }
                        };
                        setCheckoutData(next);
                        setLateCheckout(next);
                      };

                      const applyRoom = (room_id) => {
                        const next = {
                          ...checkout_data,
                          services: {
                            ...checkout_data.services,
                            [key]: {
                              ...checkout_data.services[key],
                              room_id: parseInt(room_id),
                              process_type: 2,
                            },
                          }
                        };
                        setCheckoutData(next);
                        setLateCheckout(next);
                      };

                      const staffSelectNode = (
                        <StaffSelect
                          className="mb-1"
                          disabled={context.state.user.permission === 0}
                          label={context.t(`['receipt/detail/id'].serviceTransactions.staffInputLabel`)}
                          items={staffs}
                          selected={staffId ? staffId : ""}
                          labelKey="full_name"
                          valueKey="id"
                          handler={applyStaff}
                        />
                      );

                      const roomSelectNode = (
                        <Select
                          className="mb-1"
                          disabled={context.state.user.permission === 0}
                          label="Oda"
                          items={(rooms || [])
                            .filter(room => room && (room.ID || room.id))
                            .map(room => ({
                              id: room.ID || room.id,
                              name: room.Name || room.name,
                              backgroundColor: '',
                              color: ''
                            }))}
                          selected={roomId ? roomId : ""}
                          labelKey="name"
                          valueKey="id"
                          title={roomName}
                          handler={applyRoom}
                        />
                      );

                      if (isEditingRow) {
                        return (
                          <>
                            <Column className="xs-12 sm-12 md-12 lg-3">
                              {staffSelectNode}
                            </Column>
                            <Column className="xs-12 sm-12 md-12 lg-3">
                              {roomSelectNode}
                            </Column>
                          </>
                        );
                      }

                      if (anySet) {
                        const label = bothSet ? "Personel / Oda" : (staffId ? "Personel" : "Oda");
                        const value = bothSet
                          ? `${staffName || "-"} • ${roomName || "-"}`
                          : (staffId ? staffName : roomName);
                        return (
                          <Column className="xs-12 sm-12 md-12 lg-2">
                            <TextField
                              variant="outlined"
                              label={label}
                              value={value}
                              fullWidth
                              className="mb-1"
                              onClick={() => {
                                if (context.state.user.permission !== 0) setPersonnelRoomEditKey(key);
                              }}
                              InputProps={{
                                readOnly: true,
                                style: { cursor: context.state.user.permission !== 0 ? "pointer" : "default" },
                                endAdornment: (
                                  <InputAdornment position="end" style={{ marginTop: 4, marginRight: -6, marginLeft: -12 }}>
                                    <Tooltip title="Düzenle">
                                      <Edit
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (context.state.user.permission !== 0) setPersonnelRoomEditKey(key);
                                        }}
                                        style={{ fontSize: 20, color: "#757575", cursor: "pointer" }}
                                      />
                                    </Tooltip>
                                  </InputAdornment>
                                ),
                              }}
                              InputLabelProps={{ shrink: true }}
                            />
                          </Column>
                        );
                      }

                      return (
                        <Column className="xs-12 sm-12 md-12 lg-2">
                          {staffSelectNode}
                          {roomSelectNode}
                        </Column>
                      );
                    })()}

                    {!isEditingRow && (
                    <Column className="xs-12 sm-12 md-12 lg-2">
                      <Select
                        className="mb-1"
                        disabled={context.state.user.permission === 0}
                        label={context.t(`sms.deviceStatus`)}
                        items={customer_s}
                        selected={
                          checkout_data.services[key].customer_state !== null
                            ? `${checkout_data.services[key].customer_state}`
                            : ""
                        }
                        labelKey="label"
                        valueKey="value"
                        handler={(customer_state) => {
                          setCheckoutData({
                            ...checkout_data,
                            services: {
                              ...checkout_data.services,
                              [key]: {
                                ...checkout_data.services[key],
                                customer_state: parseInt(customer_state),
                                process_type: 2,
                              },
                            }
                          });
                        }}
                      />
                    </Column>
                    )}
                    {!isEditingRow && (
                    <Column className="xs-12 sm-12 md-12 lg-2">
                      <MaskedInput
                        className="mb-1"
                        label={
                          context.t(
                            `['receipt/detail/id'].serviceTransactions.amountInputLabel`
                          ) +
                          (context.state.currency
                            ? " (" + context.state.currency + ")"
                            : "(₺)")
                        }
                        mask="9999999999999"
                        maskChar=""
                        value={
                          checkout_data.services[key].amount !== null
                            ? checkout_data.services[key].amount
                            : ""
                        }
                        onChange={(e) => {
                          setCheckoutData({
                            ...checkout_data,
                            services: {
                              ...checkout_data.services,
                              [key]: {
                                ...checkout_data.services[key],
                                amount: /[0-9,.]+/.test(e.target.value)
                                  ? Math.round(parseFloat(e.target.value))
                                  : null,
                                process_type: 2,
                              },
                            },
                          });
                          setLateCheckout({
                            ...lateCheckout,
                            services: {
                              ...lateCheckout.services,
                              [key]: {
                                ...lateCheckout.services[key],
                                amount: /[0-9,.]+/.test(e.target.value)
                                  ? Math.round(parseFloat(e.target.value))
                                  : null,
                                process_type: 2,
                              },
                            },
                          });
                        }}
                      />
                    </Column>
                    )}

                    {(!isEditingRow && !checkout_data?.services[key]?.button_passive && checkout_data?.services[key]?.id && parseFloat(checkout_data?.services[key]?.amount) > 0) && (
                      <Column className="xs-12 sm-12 md-12 lg-1">
                        <Column style={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "start", gap: "10px", height: "100%" }}>
                          <img src={Credit} title="Ödeme Ekle" style={{ cursor: "pointer" }} alt="credit" width="25px" height="25px" onClick={() => {
                            checkUnsavedChangesBeforePaymentCredit(() => {
                              setInstallmentDialog(true);
                              setInstallmentDate(true)
                            });
                            setSelected(checkout_data.services[key])
                          }} />
                          <img src={Cash} title="Ödeme Ekle" style={{ cursor: "pointer" }} alt="credit" width="25px" height="25px" onClick={() => {
                            checkUnsavedChangesBeforePayment(() => {
                              setAddPaymentDialog(true);
                              setInstallmentDate(false)
                            });
                            setSelected(checkout_data.services[key])
                          }} />
                        </Column>
                      </Column>
                    )}
                    {isEditingRow ? (
                      <Column className="xs-12 sm-12 md-12 lg-2 mt-1">
                        <Button
                          icon="check"
                          iconSize={18}
                          title="Tamam"
                          backgroundColor="primary"
                          textColor="white"
                          size="md"
                          fullWidth
                          onClick={() => setPersonnelRoomEditKey(null)}
                        />
                      </Column>
                    ) : (
                    <Column className="xs-12 sm-12 md-12 lg-1 mt-1">
                      <Button
                        icon={checkout_data?.services[key]?.appointment_id === 0 || !checkout_data?.services[key]?.appointment_id ? "event" : 'event_available'}
                        iconSize={21}
                        buttonTitle={checkout_data?.services[key]?.appointment_id === 0 || !checkout_data?.services[key]?.appointment_id ? "Randevu Oluştur" : 'Randevuya Git'}
                        textColor={checkout_data?.services[key]?.appointment_id === 0 || !checkout_data?.services[key]?.appointment_id ? "blue" : "green"}
                        size="sm"
                        onClick={() => {
                          if (checkout_data?.services[key]?.appointment_id === 0 || !checkout_data?.services[key]?.appointment_id) {
                            if (!checkout_data?.services[key]?.id) {
                              toast.warning(
                                context.t(`["receipt/detail/id"].saveBeforeGetAppointmentWarnToast`)
                              );
                            } else if (packageChanges || hasUnsavedChanges) {
                              toast.warning(
                                context.t(`["receipt/detail/id"].saveBeforeGetAppointmentWarnToast`)
                              );
                            } else {
                              setCheckoutDataDialog(true);
                              setSelectedTime(moment().hour() + ":" + moment().minutes());
                              setSelectedDate(
                                new Date(
                                  checkout_data.services[key].process_date
                                ).toISOString()
                              );
                              setSelectedReceiptId(checkout_data.services[key].id);
                              setSelectedService(checkout_data.services[key].service_id);
                              setSelectedStaffParent(checkout_data.services[key].staff_id);
                            }
                          } else {
                            getAppointment(checkout_data?.services[key]?.appointment_id);
                            setAppointmentDetailModal(true);
                          }
                        }}
                      />
                    </Column>
                    )}
                  </Grid>
                );
              }
            )
          ) : (
            <NoDataContainer style={{ height: "80%" }}>
              <img
                src={require("../../../../assets/images/no-data-img.png")}
                alt="Malesef bulunamadı!"
              />
              <p>
                {context.t(
                  `['receipt/detail/id'].serviceTransactions.noDataText`
                )}
              </p>
            </NoDataContainer>
          )
        }
      </ListSection>
      <AlertDialog
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Warning style={{ color: "#FFA500", marginRight: "10px" }} />
            <span>Adisyonu Kaydetmediniz</span>
          </div>
        }
        open={saveCashDialogOpen}
        fullWidth
        maxWidth="xs"
        closeHandler={() => setSaveCashDialogOpen(false)}
        buttons={[
          {
            title: "Kaydet ve Devam Et",
            icon: "check",
            backgroundColor: "green",
            validationButton: true,
            style: { height: "56px" },
            textColor: "white",
            onClick: () => saveReceiptAndContinue(),
          },
          {
            title: "İptal",
            icon: "close",
            backgroundColor: "white",
            style: {
              border: "1px solid #666666",
              height: "56px",
            },
            textColor: "black",
            onClick: () => setSaveCashDialogOpen(false),
          },
        ]}
      >
        <p>Fiyat değişikliği yaptınız ancak adisyonu kaydetmediniz. Devam etmeden önce kaydetmek ister misiniz?</p>
      </AlertDialog>
      <AlertDialog
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Warning style={{ color: "#FFA500", marginRight: "10px" }} />
            <span>Adisyonu Kaydetmediniz</span>
          </div>
        }
        open={saveCreditDialogOpen}
        fullWidth
        maxWidth="xs"
        closeHandler={() => setSaveCreditDialogOpen(false)}
        buttons={[
          {
            title: "Kaydet ve Devam Et",
            icon: "check",
            backgroundColor: "green",
            validationButton: true,
            style: { height: "56px" },
            textColor: "white",
            onClick: () => saveReceiptAndContinueCredit(),
          },
          {
            title: "İptal",
            icon: "close",
            backgroundColor: "white",
            style: {
              border: "1px solid #666666",
              height: "56px",
            },
            textColor: "black",
            onClick: () => setSaveCreditDialogOpen(false),
          },
        ]}
      >
        <p>Fiyat değişikliği yaptınız ancak adisyonu kaydetmediniz. Devam etmeden önce kaydetmek ister misiniz?</p>
      </AlertDialog>
      <AlertDialog
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "5px",
            }}
          >
            <AddOutlined
              style={{
                color: "#6097D2",
              }}
            />
            <span
              style={{
                color: "#6097D2",
              }}
            >
              {context.t(`['receipt/detail/id'].addPaymentTitle`)}
            </span>
          </div>
        }
        open={addPayment_dialog}
        fullWidth
        maxWidth="xs"
        closeHandler={() => setAddPaymentDialog(false)}
        buttons={[
          {
            title: context.t(
              `appointments.create.completePaymentButtonTitle`
            ),
            icon: "check",
            backgroundColor: "green",
            validationButton: true,
            style: {
              height: "56px",
            },
            textColor: "white",
            onClick: () => {
              if (!advanced_date || !advanced_amount || advanced_amount <= 0) {
                toast.error('Lütfen tüm alanları doldurunuz!');
                return;
              }
              if (!selected?.id) {
                toast.error('Lütfen bir hizmet seçiniz!');
                return;
              }
              singlePaymentAndInstallmentPayment({
                receipt_id: parseInt(checkout_data.receipt_id),
                id: parseInt(selected.id),
                receipt_type: 1,
                is_installment: false,
                payments: [{
                  payment_date: moment(advanced_date).toISOString(),
                  payment_type: advanced_type,
                  staff_id: parseInt(payment_select_staff?.staff_id),
                  amount: parseFloat(advanced_amount),
                  payment_status: 1,
                }]
              })
              setSelected(null)
              setSelectedInstallment(null)
              setInstallmentDate(null)
              setSelectedStaff(null)
              setAdvancedDate(new Date())
              setAdvancedType(0)
              setAdvancedStaff(null)
              setAdvancedAmount(null)
              setPaymentSelectStaff({})
              setAddPaymentDialog(false)
            },
          },
          {
            title: context.t(`appointments.create.discardButtonTitle`),
            icon: "close",
            backgroundColor: "white",
            style: {
              border: "1px solid #666666",
              height: "56px",
            },
            textColor: "black",
            onClick: () => {
              setAddPaymentDialog(false);
              setPaymentSelectStaff({});
              setAdvancedStaff(null);
            },
          },
        ]}
      >
        <>
          <Column>
            <span
              style={{
                marginBottom: "10px",
                marginLeft: "5px",
                fontSize: "18px",
              }}
            >
              {context.t(`["receipt/detail/id"].payments.dateInputLabel`)} *
            </span>
            <DatePickerInput
              value={moment(advanced_date).local().toISOString() || new Date()}
              onChange={(payment_date) => {
                setAdvancedDate(payment_date);
              }}
            />
          </Column>
          <Column>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <AdvancedType
                style={{
                  backgroundColor: advanced_type == 0 ? "#78B8FF" : "#FFFFFF",
                  filter:
                    advanced_type == 0
                      ? "drop-shadow(0px 3px 6px #78B8FF)"
                      : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                  border:
                    advanced_type == 0
                      ? "1px solid #6BB0FE"
                      : "1px solid #b8b8b8",
                }}
                onClick={() => setAdvancedType(0)}
              >
                {advanced_type == 0 ? (
                  <img src={CashWhite} alt="cash_white" />
                ) : (
                  <img src={Cash} alt="cash" />
                )}
                <span
                  style={{
                    color: advanced_type == 0 ? "#FFFFFF" : "#000000",
                  }}
                >
                  {context.t(`accounting.typeCASH`)}
                </span>
              </AdvancedType>
              <AdvancedType
                style={{
                  marginLeft: "10px",
                  backgroundColor: advanced_type == 2 ? "#78B8FF" : "#FFFFFF",
                  filter:
                    advanced_type == 2
                      ? "drop-shadow(0px 3px 6px #78B8FF)"
                      : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                  border:
                    advanced_type == 2
                      ? "1px solid #6BB0FE"
                      : "1px solid #b8b8b8",
                }}
                onClick={() => {
                  setAdvancedType(2);
                }}
              >
                {advanced_type == 2 ? (
                  <img src={TransferWhite} alt="transfer_white" />
                ) : (
                  <img src={Transfer} alt="transfer" />
                )}
                <span
                  style={{
                    color: advanced_type == 2 ? "#FFFFFF" : "#000000",
                  }}
                >
                  {context.t(`accounting.typeEFT`)}
                </span>
              </AdvancedType>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <AdvancedType
                style={{
                  backgroundColor: advanced_type == 1 ? "#78B8FF" : "#FFFFFF",
                  filter:
                    advanced_type == 1
                      ? "drop-shadow(0px 3px 6px #78B8FF)"
                      : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                  border:
                    advanced_type == 1
                      ? "1px solid #6BB0FE"
                      : "1px solid #b8b8b8",
                }}
                onClick={() => {
                  setAdvancedType(1);
                }}
              >
                {advanced_type == 1 ? (
                  <img src={CreditWhite} alt="credit_white" />
                ) : (
                  <img src={Credit} alt="credit" />
                )}
                <span
                  style={{
                    color: advanced_type == 1 ? "#FFFFFF" : "#000000",
                  }}
                >
                  {context.t(`accounting.typeCARD`)}
                </span>
              </AdvancedType>
              <AdvancedType
                style={{
                  marginLeft: "10px",
                  backgroundColor: advanced_type == 3 ? "#78B8FF" : "#FFFFFF",
                  filter:
                    advanced_type == 3
                      ? "drop-shadow(0px 3px 6px #78B8FF)"
                      : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                  border:
                    advanced_type == 3
                      ? "1px solid #6BB0FE"
                      : "1px solid #b8b8b8",
                }}
                onClick={() => {
                  setAdvancedType(3);
                }}
              >
                {advanced_type == 3 ? (
                  <img src={CustomerPointWhite} alt="customer_point_white" />
                ) : (
                  <img src={CustomerPoint} alt="customer_point" />
                )}
                <span
                  style={{
                    color: advanced_type == 3 ? "#FFFFFF" : "#000000",
                  }}
                >
                  {context.t(`["accounting/expense"].payments.cusPoint`)}
                </span>
              </AdvancedType>
            </div>
          </Column>
          <Column>
            <StaffSelect
              disabled={context.state.user.permission === 0}
              label={context.t(`["receipt/detail/id"].selectStaff`)}
              items={staffs}
              selected={payment_select_staff?.staff_id}
              labelKey="full_name"
              valueKey="id"
              returnFullObject
              handler={(staff) => {
                setAdvancedStaff(staff);
                setPaymentSelectStaff({
                  ...payment_select_staff,
                  staff_id: parseInt(staff.id),
                });
              }}
            />
          </Column>
          <Column>
            <span
              style={{
                marginBottom: "10px",
                marginLeft: "5px",
                fontSize: "18px",
              }}
            >
              {context.t(`["receipt/detail/id"].paymentAmount`)} *
            </span>
            <MaskedInput
              mask="9999999999999"
              maskChar=""
              value={advanced_amount ? advanced_amount : ""}
              onChange={(e) => {
                setAdvancedAmount(e.target.value);
              }}
            />
          </Column>
        </>
      </AlertDialog>
      <AlertDialog
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <span
              style={{
                width: "120%",
                marginTop: "15px",
              }}
            >
              {context.t(`['receipt/detail/id'].installmentProcess`)}
            </span>
            <CustomerBoxDiv>
              {selected?.amount === 0 ? (
                <img src={RemainingDebt} alt="remaining_debt" />
              ) : (
                <img src={RemainingDebtRed} alt="remaining_debt_red" />
              )}
              <CustomerPointBox>
                <span>
                  {getInstallmentDiffTotal(1)}{" "}
                  {context.state.currency ? context.state.currency : "₺"}
                </span>
                <h3>{context.t(`['receipt/detail/id'].remainingDebt`)}</h3>
              </CustomerPointBox>
            </CustomerBoxDiv>
          </div>
        }
        open={installment_dialog}
        closeHandler={() => setInstallmentDialog(false)}
        fullWidth
        maxWidth="sm"
        buttons={[
          {
            title: context.t(`appointments.create.completeButtonTitle`),
            icon: "check",
            validationButton: true,
            backgroundColor: "green",
            style: {
              height: "56px",
            },
            textColor: "white",
            onClick: () => {
              if (!installment_date || !selected_installment) {
                toast.error('Lütfen tüm alanları doldurunuz!');
                return;
              }
              if (!selected?.id) {
                toast.error('Lütfen bir hizmet seçiniz!');
                return;
              }
              singlePaymentAndInstallmentPayment({
                receipt_id: parseInt(checkout_data.receipt_id),
                id: parseInt(selected.id),
                receipt_type: 1,
                is_installment: true,
                payments: Array.from({ length: selected_installment }, (_, i) => ({
                  payment_date:
                    i === 0
                      ? moment(installment_date).toISOString()
                      : moment(installment_date)
                        .add(i, "months")
                        .toISOString(),
                  payment_type: 0,
                  staff_id: parseInt(selectedStaff),
                  amount:
                    getInstallmentDiffTotal(selected_installment),
                  payment_status: 0,
                }))
              })
              setSelected(null)
              setSelectedInstallment(null)
              setInstallmentDate(null)
              setSelectedStaff(null)
              setAdvancedDate(new Date())
              setAdvancedType(0)
              setAdvancedStaff(null)
              setInstallmentDialog(false)
            },
          },
          {
            title: context.t(`appointments.create.discardButtonTitle`),
            icon: "close",
            backgroundColor: "white",
            style: {
              border: "1px solid #666666",
              height: "56px",
            },
            textColor: "black",
            onClick: () => setInstallmentDialog(false),
          },
        ]}
      >
        <>
          <Column>
            <span
              style={{
                marginBottom: "10px",
                marginLeft: "5px",
                fontSize: "18px",
              }}
            >
              {context.t(`["receipt/detail/id"].payments.dateInputLabel`)} *
            </span>
            <DatePickerInput
              value={moment(installment_date).local().toISOString() || new Date()}
              onChange={(payment_date) => {
                setInstallmentDate(payment_date);
              }}
            />
          </Column>
          <Column>
            <span
              style={{
                marginBottom: "10px",
                marginLeft: "5px",
                fontSize: "18px",
              }}
            >
              {context.t(`["receipt/detail/id"].installmentStaffInputLabel`)} *
            </span>
            <StaffSelect
              className="mb-1"
              disabled={context.state.user.permission === 0}
              label={context.t(
                `['receipt/detail/id'].serviceTransactions.staffInputLabel`
              )}
              items={staffs}
              selected={selectedStaff ? selectedStaff : ""}
              labelKey="full_name"
              valueKey="id"
              handler={(staff_id) => {
                setSelectedStaff(staff_id)
              }}
            />
          </Column>
          <Column>
            <span
              style={{
                marginTop: '20px !important',
                marginBottom: "10px",
                marginLeft: "5px",
                fontSize: "18px",
              }}
            >
              {context.t(`["receipt/detail/id"].installmentCountInputLabel`)} *
            </span>
            <Select
              labelKey="label"
              valueKey="value"
              items={[
                { value: 2, label: context.t(`["receipt/detail/id"].installments.two`) },
                { value: 3, label: context.t(`["receipt/detail/id"].installments.three`) },
                { value: 4, label: context.t(`["receipt/detail/id"].installments.four`) },
                { value: 5, label: context.t(`["receipt/detail/id"].installments.five`) },
                { value: 6, label: context.t(`["receipt/detail/id"].installments.six`) },
                { value: 7, label: context.t(`["receipt/detail/id"].installments.seven`) },
                { value: 8, label: context.t(`["receipt/detail/id"].installments.eight`) },
                { value: 9, label: context.t(`["receipt/detail/id"].installments.nine`) },
                { value: 10, label: context.t(`["receipt/detail/id"].installments.ten`) },
                { value: 11, label: context.t(`["receipt/detail/id"].installments.eleven`) },
                { value: 12, label: context.t(`["receipt/detail/id"].installments.twelve`) },
              ]}
              selected={selected_installment ? selected_installment : null}
              handler={(installment) => {
                setSelectedInstallment(installment);
              }}
            />
          </Column>
          {selected_installment && (
            <Column>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <p style={{ marginRight: "5px" }}>{context.t(`["receipt/detail/id"].payments.title`)}:</p>
                <p>
                  {Math.round(getInstallmentDiffTotal(selected_installment))}
                  {context.state.currency
                    ? context.state.currency
                    : "₺"} x {selected_installment}
                </p>
              </div>
            </Column>
          )}
        </>
      </AlertDialog>

      {Object.keys(checkout_data.services).filter(
        (key) => checkout_data.services[key] !== undefined
      ).length > 0 && (
          <SubTotalText className="mt-2">
            <CustomerBoxDiv>
              <Button
                style={{
                  border: "1px solid rgba(255, 127, 80, 0.53)",
                }}
                disabled={
                  Object.keys(checkout_data.services).filter(
                    (key) => checkout_data.services[key] !== undefined
                  ).length === 0
                }
                className="mr-2"
                icon="emoji_symbols"
                title={context.t(
                  `['receipt/detail/id'].applyDiscountButtonTitle`
                )}
                backgroundColor="orange-opacity"
                textColor="orange"
                onClick={() => {
                  if (
                    Object.keys(checkout_data.paids).filter(
                      (key) => checkout_data.paids[key] !== undefined
                    ).length === 0 &&
                    Object.keys(checkout_data.installment).filter(
                      (key) => checkout_data.installment[key] !== undefined
                    ).length === 0
                  ) {
                    setDiscountTarget("services");
                    setDiscountValue(null)
                    setDiscountType("")
                    setDiscountModal(true)
                  } else {
                    toast.warning(
                      context.t(
                        `['receipt/detail/id'].discountBeforePaymentToast`
                      )
                    );
                  }
                }}
              />
              <div
                style={{
                  marginLeft: "auto",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={RemainingDebtRed} alt="remaining_debt_red" />
                <CustomerPointBox>
                  {getTotalAmounts().services !=
                    getTotalAmounts()._fservices ? (
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <p
                        style={{ textDecoration: "line-through" }}
                        className="fc-grey mr-1"
                      >
                        {getTotalAmounts()._fservices.toFixed(0)}
                        {context.state.currency
                          ? context.state.currency
                          : "₺"}
                      </p>
                      <p>
                        {getTotalAmounts().services.toFixed(0)}
                        {context.state.currency
                          ? context.state.currency
                          : "₺"}
                      </p>
                    </span>
                  ) : (
                    <span>
                      <p>
                        {Math.round(getTotalAmounts().services)}
                        {context.state.currency
                          ? context.state.currency
                          : "₺"}
                      </p>
                    </span>
                  )}
                  <h3>
                    {context.t(
                      `['receipt/detail/id'].serviceTransactions.totalAmount`
                    )}
                  </h3>
                </CustomerPointBox>
              </div>
            </CustomerBoxDiv>
          </SubTotalText>
        )}
    </SectionBox>
  );
};

// Servis satışını eklemek için açılan dialog.

export const _ServiceSalesDialogBuilder = ({
  service_transaction,
  setServiceTransaction,
  service_transaction_modal,
  setServiceTransactionModal,
  addSingleServiceIntoCheckout,
  staffs,
  rooms,
  setSelectedStaffServices,
  selected_staff_services,
  searchServicesByKey,
  loadMoreServices,
  resetServicesPagination,
}) => {
  const context = useContext(AppContext);

  return (
    <AlertDialog
      containerStyle={{
        overflow: "visible",
      }}
      fullWidth
      maxWidth="sm"
      title={context.t(`['receipt/detail/id'].serviceTransaction.title`)}
      open={service_transaction_modal}
      closeHandler={() => setServiceTransactionModal(false)}
      buttons={[
        {
          title: context.t(
            `['receipt/detail/id'].serviceTransaction.addButtonTitle`
          ),
          icon: "check",
          backgroundColor: "primary-opacity",
          textColor: "primary",
          onClick: () => addSingleServiceIntoCheckout(),
        },
        {
          title: context.t(
            `['receipt/detail/id'].serviceTransaction.discardButtonTitle`
          ),
          icon: "close",
          textColor: "grey",
        },
      ]}
    >
      <StaffSelect
        optional
        disabled={context.state.user.permission === 0}
        label={context.t(
          `['receipt/detail/id'].serviceTransaction.staffInputLabel`
        )}
        items={staffs}
        selected={service_transaction.staff_id || ""}
        labelKey="full_name"
        valueKey="id"
        returnFullObject
        handler={async (staff) => {
          if (staff === "" || !staff || !staff.id) {
            setServiceTransaction({
              ...service_transaction,
              staff_id: null,
            })
          } else {
            setServiceTransaction({
              ...service_transaction,
              staff_id: parseInt(staff.id),
            })
          }
          // Mevcut hizmet seçimini temizle
          setSelectedStaffServices(null);
          // Reset pagination
          if (resetServicesPagination) {
            resetServicesPagination();
          }
        }}
      />

      <Select
        disabled={context.state.user.permission === 0}
        label="Oda"
        items={[
          {
            id: null,
            name: "Oda Seçiniz",
          },
          ...(rooms || [])
            .filter(room => room && (room.ID || room.id))
            .map(room => ({
              id: room.ID || room.id,
              name: room.Name || room.name,
            }))
        ]}
        selected={service_transaction.room_id || ""}
        labelKey="name"
        valueKey="id"
        handler={async (room_id) => {
          setServiceTransaction({
            ...service_transaction,
            room_id: room_id !== null ? parseInt(room_id) : null,
          })
          // Mevcut hizmet seçimini temizle
          setSelectedStaffServices(null);
          // Reset pagination
          if (resetServicesPagination) {
            resetServicesPagination();
          }
        }}
      />

      <AutocompleteInput
        label={context.t(
          `['receipt/detail/id'].serviceTransaction.serviceInputLabel`
        )}
        labelKey="name"
        showField="amount"
        style={{ zIndex: "9999" }}
        // opcStyle={{ marginTop: "-80px" }}
        valueKey="id"
        selected={
          selected_staff_services !== null
            ? selected_staff_services
            : ""
        }
        onRemove={() => {
          setSelectedStaffServices(null);
          searchServicesByKey("");
        }}
        returnFullObject
        selectedHandler={(service) => {
          setServiceTransaction({
            ...service_transaction,
            service_id: parseInt(service.id),
            amount: Math.round(service.amount),
            first_amount: Math.round(service.amount),
            process_date: moment().format("YYYY-MM-DD"),
            process_type: 2,
          });
          console.log(service_transaction);
        }}
        asyncDataService={(keyword) => searchServicesByKey(keyword)}
        onScrollBottom={loadMoreServices}
        placeholder={context.t(`['receipt/detail/id'].serviceTransactions.searchPlaceholder`)}
      />
    </AlertDialog>
  );
};

const SectionBox = styled.div`
  width: 100%;
  overflow-x: scroll;
  box-sizing: border-box;
  padding-top: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SectionHeading = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  color: var(--dark-primary);

  h3{font - size: 18px; font-weight: 600; flex: 1; margin: 0; padding: 0}
`;

const ListSection = styled.div`
  overflow-x: scroll;
  margin-bottom: auto;
  padding-left: 5px;
  padding-right: 5px;
`;

const SubTotalText = styled.div`
  span {
    font-size: 13px;
    font-weight: 500;
    padding: 0;
    margin: 0;
  }

  p {
    font-size: 17px;
    font-weight: 400;
    padding: 0;
    margin: 0;
  }
`;

const CustomerBoxDiv = styled.div`
  width: 100%;
  height: 57px;
  padding: 8px;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 5px;

  img {
    width: 30px;
    height: 30px;
    margin-right: 8px;
    margin-top: 7px;
    margin-left: 10px;
  }
`;

const CustomerPointBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  margin-top: 5px;

  h3 {
    font-size: 13px;
    font-weight: 500;
    margin: 0;
    color: #3c3c3c;
  }

  span {
    font-size: 15px;
    font-weight: 500;
    line-height: 15px;

    b {
      font-size: 13px;
      font-weight: 400;
      color: #aaa;
    }
  }
`;

const NoDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 16px;

  img {
    width: 100%;
    max-height: 32vh;
    object-fit: contain;
  }
  p {
    color: #407bff;
    font-size: 18px;
    font-weight: 500;
    padding-top: 16px;
    text-align: center;
  }
`;

const AdvancedType = styled.div`
  display: flex;
  width: 190px;
  height: 88px;
  border-radius: 8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  cursor: pointer;
`;